export const MAX_AGENT_DRAFT_BYTES = 64 * 1024;
export const MAX_AGENT_DRAFT_HASH_CHARS = Math.ceil(MAX_AGENT_DRAFT_BYTES / 3) * 4 + 32;
